import React from "react";
import "./InfoButton.scss";

interface IProps {
    onClick: () => void;
    visible: boolean;
}

export function InfoButton({ onClick, visible }: IProps) {
    return (
        <div className={`info-button-wrapper ${visible ? 'visible' : ''}`} >
            <div className="info-button" onClick={onClick}>i</div>
            <div className="pulse"/>
            <div className="pulse"/>
            <div className="pulse"/>
        </div>
    )
}
